import React, { useEffect, useState } from "react";

// APP COMPONENTS
import PercentageInput from "../../Inputs/percentageInput";
// MATERIAL UI COMPONENTS
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import ModalHeader from "../../modals/modalHeader";
import { ButtonSuccessNoShadow } from "../../styled/button";
import { Fade } from "@mui/material";
import { setDeliveryCenterServiceFee } from "../../../api/DeliveryCenter/deliveryCenter";
import { ERROR_MESSAGE_SUPPORT } from "../../../common/helpersTxt";
import LoadingBox from "../../indicators/LoadingBox";
import CollapseAlert from "../../alerts/CollapseAlert";
import Box from "@mui/material/Box";
import { StyledModalRoot } from "../../styled/modal";
import { LightGreyBox } from "../../styled";

export default function OperatorFeeModal({
  show,
  saloonFee,
  counterFee,
  closeModal,
}) {
  const [loading, setLoading] = useState(false);
  const [saloonFeeValue, setSaloonFeeValue] = useState(saloonFee || 0);
  const [counterFeeValue, setCounterFeeValue] = useState(counterFee || 0);

  const [openAlert, setOpenAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("error");
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    setSaloonFeeValue(saloonFee);
  }, [saloonFee]);

  useEffect(() => {
    setCounterFeeValue(counterFee);
  }, [counterFee]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await handleSetDeliveryCenterServiceFee();
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const handleSetDeliveryCenterServiceFee = async () => {
    try {
      setLoading(true);
      const feesObj = {
        saloon: saloonFeeValue || 0,
        counter: counterFeeValue || 0,
      };
      await setDeliveryCenterServiceFee(feesObj);

      const message = "Taxas de Serviço atualizadas com sucesso";
      handleAlert("success", message, true);
    } catch (e) {
      const message =
        e.response?.data.error || "Erro ao definir taxas de serviço";
      handleAlert("error", message, true);
    } finally {
      setLoading(false);
    }
  };

  const handleAlert = (
    severity = "error",
    message = ERROR_MESSAGE_SUPPORT,
    open = true
  ) => {
    setAlertSeverity(severity);
    setAlertMessage(message);
    setOpenAlert(open);
  };

  if (loading) {
    return <LoadingBox />;
  }

  return (
    <Modal
      open={show}
      onClose={closeModal}
      closeAfterTransition
      sx={{
        zIndex: 5000,
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Fade in={show}>
        <StyledModalRoot>
          <ModalHeader label="Taxa de Serviço" onClose={closeModal} />
          <Box sx={{ p: 6 }}>
            <LightGreyBox>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <PercentageInput
                    fullWidth
                    label="Salão"
                    value={saloonFeeValue}
                    onChange={setSaloonFeeValue}
                  />
                </Grid>

                <Grid item xs={12}>
                  <PercentageInput
                    fullWidth
                    label="Balcão"
                    value={counterFeeValue}
                    onChange={setCounterFeeValue}
                  />
                </Grid>
              </Grid>
            </LightGreyBox>
            <ButtonSuccessNoShadow
              type="submit"
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              sx={{ mt: 4 }}
            >
              Salvar
            </ButtonSuccessNoShadow>
          </Box>

          <Box sx={{ my: 2 }}>
            <CollapseAlert
              severity={alertSeverity}
              errorMessage={alertMessage}
              openErrorAlert={openAlert}
              setOpenErrorAlert={setOpenAlert}
            />
          </Box>
        </StyledModalRoot>
      </Fade>
    </Modal>
  );
}
